import { DateTime } from "luxon";
import { Offers } from "../Const";

/**
 *
 * @param {OfferCategory[]} offersCategoryCount - Nombre d'offres par catégorie
 * @param {Object[]} offerCategoriesData - Liste des catégories d'offres.
 * @param {string} offerCategoriesData[].label - Nom de la catégorie
 *
 * @returns {NivoPieChartData} données formattées pour Nivo
 */
export function getOffersByCategoryData(
  offersCategoryCount,
  offerCategoriesData
) {
  /** @type {NivoPieChartData} */
  let chartData = [];

  //? Pour chaque catégorie on créé un objet avec le nom de la catégorie et le nombre d'offres associées
  for (const categoryItem of offerCategoriesData) {
    /** @type {NivoChartData} */
    let data = {
      id: categoryItem.label,
      label: categoryItem.label,
      value:
        offersCategoryCount?.find(
          (category) => category.label === categoryItem.label
        )?.total || 0,
    };
    chartData.push(data);
  }

  return chartData;
}

/**
 * Récupération des données pour le graphique des offres par catégorie par mois
 *
 * @param {MonthlyOfferCategoryData[]} offersMonthlyCountData - Données offre par catégorie par mois
 * @param {Object[]} offerCategoriesData - Liste des catégories d'offres.
 * @param {string} offerCategoriesData[].label - Nom de la catégorie
 * @param {DateTime} afterDate - Date de début de la période choisie, optionnelle (type DateTime de Luxon)
 * @param {DateTime} beforeDate - Date de fin de la période choisie, optionnelle (type DateTime de Luxon)
 *
 * @returns {NivoBarChartData}  données formattées pour Nivo
 */
export function getOffersByCategoryByMonthData(
  offersMonthlyCountData,
  offerCategoriesData,
  afterDate = 0,
  beforeDate = 0
) {
  // Par défaut on prend les 6 derniers mois (hors actuel)
  if (afterDate === 0)
    afterDate = DateTime.local()
      .startOf("month")
      .minus({ months: 6 })
      .plus({ days: 1 });
  else afterDate = DateTime.fromJSDate(afterDate);
  if (beforeDate === 0)
    beforeDate = DateTime.local().endOf("month").minus({ months: 1 });
  else beforeDate = DateTime.fromJSDate(beforeDate);

  /* Nombre de mois entre la date de début et la date de fin */
  let differential = Math.round(
    Math.abs(beforeDate.diff(afterDate, "months").values.months)
  );

  /** @type {NivoBarChartData} */
  const chartData = [];

  //? Pour chaque mois on crée un objet
  for (let j = 0; j < differential; ++j) {
    const currentMonth = afterDate
      ?.plus({ month: j })
      ?.setLocale("fr")
      ?.toFormat("MM-yyyy");
    chartData?.push({
      date: currentMonth,
    });
  }

  for (let j = 0; j < chartData.length; ++j) {
    const currentDate = chartData[j]?.date;
    const dateData = offersMonthlyCountData.find((data) =>
      Object.prototype.hasOwnProperty.call(data, currentDate)
    );
    if (dateData !== undefined) {
      //? pour chaque date on créé un objet avec le nom de la catégorie et le nombre d'offres associées
      const offersCategories = dateData[currentDate];
      const monthObject = { date: currentDate };
      //? On ajoute toutes les catégories d'offres à l'objet par défaut à 0
      offerCategoriesData.forEach((category, index) => {
        monthObject[category?.label] = 0;
        //? On ajoute la couleur de la catégorie à l'objet
        monthObject[`${category?.label}Color`] = Offers.categoriesColor[index];
      });
      //? On remplace le nombre d'offres par catégorie depuis les données de la requête
      offersCategories?.forEach((category) => {
        monthObject[category?.label] = category?.total;
      });
      chartData[j] = monthObject;
    }
  }

  return chartData;
}
